import { useGetConversationActivityQuery } from '@shared/generated/graphql';
import { useEffect, useMemo } from 'react';
import { useRefetchOnActionExecutionUpdates } from './useRefetchOnActionExecutionUpdates';

const WORKING_POLL_INTERVAL_MS = 2 * 1000;
const IDLE_FALLBACK_POLL_INTERVAL_MS = 60 * 1000;

export function useConversationIsWorking(conversationId: string): boolean {
  const { data, refetch, startPolling, stopPolling } =
    useGetConversationActivityQuery({
      variables: { id: conversationId },
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    });
  const isWorking = Boolean(
    data?.conversationById.hasActionExecutionInProgress
  );
  const conversationIds = useMemo(() => [conversationId], [conversationId]);
  useRefetchOnActionExecutionUpdates(conversationIds, refetch);

  useEffect(() => {
    startPolling(
      isWorking ? WORKING_POLL_INTERVAL_MS : IDLE_FALLBACK_POLL_INTERVAL_MS
    );
    return stopPolling;
  }, [isWorking, startPolling, stopPolling]);

  return isWorking;
}
